// 促销活动
const Index = () => import('@/views/promotion/Index')
const Sale = () => import('@/views/promotion/Sale')
const Resource = () => import('@/views/promotion/Resource')
const Jin = () => import('@/views/promotion/Jin')

export default [
  {
    path: '/promotion',
    component: Index,
    meta: {
      title: '非洲中东旅游节'
    }
  },
  {
    path: '/promotion/sale',
    component: Sale,
    meta: {
      title: '抢购活动'
    }
  },
  {
    path: '/promotion/resource',
    component: Resource,
    meta: {
      title: '非洲中东旅游节'
    }
  },
  {
    path: '/promotion/jin',
    component: Jin,
    meta: {
      title: '锦鲤来了'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/promotion.js